<!-- 运行环境左侧列表项 -->
<template>
  <div class='h100vh-116'>
    <div class='h-scroll h100-40'>
      <div id='randomId'>
        <ejs-listview id='flat-list' ref="runEnvironmentLeft" :dataSource='runEnvironmentList' :fields='runEnvironmentField' :select='selectEnvironment'></ejs-listview>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "runEnvironment-left",
  data(){
    return{
      runEnvironmentList: [
        //{'id': 'list-1', 'name': 'POC-DP服务'},
        //{'id': 'list-2', 'name': 'Kubernetes'},
        //{'id': 'list-3', 'name': '基站设备'},
        //{'id': 'list-4', 'name': '服务器'}/*,
        // {'id': 'list-5', 'name': 'OpenStack'},
        // {'id': 'list-6', 'name': 'Aliyun'}*/
      ],
      runEnvironmentField: {id: 'id', text: 'name', tooltip: 'name'},
      installProductList: []
    }
  },
  methods: {
    // 点击运行环境事件
    selectEnvironment(args){
      this.$emit('getSelectItem', args.data.id, args.data.name);
    },
    getInstallProductList() {
      const $this = this;
      $this.runEnvironmentList = [];
      this.$axios.post('/lte/ems/env/getInstallProductList.html', '').then((response) => {
        //if (response && response.status === 200) {
        //  if (response.data.errorCode === 'SUCCESS') {
            //$this.installProductList = response.data.resultVal;
            $this.installProductList = ["5"];
            if ($this.installProductList.includes('9')) { // POC微服务
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-1', name: 'POC-DP' }]);
             /* $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-3', name: '基站设备' }]);
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-4', name: '服务器' }]);*/
            }
            if ($this.installProductList.includes('2') || $this.installProductList.includes('8') || $this.installProductList.includes('3')|| $this.installProductList.includes('4')) {
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-3', name: '基站设备' }]);
            }
            if ($this.installProductList.includes('1') || $this.installProductList.includes('6') || $this.installProductList.includes('7') || $this.installProductList.includes('8')) {
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-4', name: '服务器' }]);
            }
            if ($this.installProductList.includes('5')) { // 5GC
              // $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-2', name: 'Kubernetes' }]);
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-3', name: `${this.$t('Topo.bStation')}` }]);
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-7', name: `${this.$t('Topo.bStationEdition')}` }]);
            //  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-9', name: `${this.$t('Topo.patchVersion')}` }]);
             //20231115 调整 基站升级和补丁升级为独立的菜单
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-5', name: `${this.$t('Software.updManage')}` }]);
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-6', name: `${this.$t('Topo.patchVersionUpgrade')}` }]);
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-10', name: `${this.$t('Topo.deviceReback')}` }]);
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-11', name: `${this.$t('Software.tscipautodistribute')}` }]);
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-12', name: `${this.$t('System.batchInitNECfg')}` }]);
              // $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-8', name: `${this.$t('Topo.nelementMana')}` }]);
            }
            // $this.$refs.runEnvironmentLeft.ej2Instances.refresh();

            this.$emit('getSelectItem', $this.runEnvironmentList[0].id, $this.runEnvironmentList[0].name);
            this.$refs.runEnvironmentLeft.selectItem({ id: $this.runEnvironmentList[0].id, name: $this.runEnvironmentList[0].name });
         // }
       // }
      });
    },
    getInstallProductListTest() {//本地后台启动需要此方法
      const $this = this;
      $this.runEnvironmentList = [];
      this.$axios.post('/lte/ems/env/getInstallProductList.html', '').then((response) => {
        // if (response && response.status === 200) {
          // if (response.data.errorCode === 'SUCCESS') {
            $this.installProductList = ["8"];
            if ($this.installProductList.includes('9')) { // POC微服务
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-1', name: 'POC-DP' }]);
             /* $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-3', name: '基站设备' }]);
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-4', name: '服务器' }]);*/
            }
            if ($this.installProductList.includes('4') || $this.installProductList.includes('5') || $this.installProductList.includes('6') || $this.installProductList.includes('7')) {
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-3', name: '基站设备' }]);
            }
            if ($this.installProductList.includes('1') || $this.installProductList.includes('2') || $this.installProductList.includes('3') || $this.installProductList.includes('5') || $this.installProductList.includes('7')) {
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-4', name: '服务器' }]);
            }
            if ($this.installProductList.includes('8')) { // 5GC
            //  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-2', name: 'Kubernetes' }]);
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-3', name: '基站设备' }]);
              $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-7', name: '基站版本' }]);
            //  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-9', name: `${this.$t('Topo.patchVersion')}` }]);
                          //20231115 调整 基站升级和补丁升级为独立的菜单
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-5', name: `${this.$t('Software.updManage')}` }]);
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-6', name: `${this.$t('Topo.patchVersionUpgrade')}` }]);
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-10', name: `${this.$t('Topo.deviceReback')}` }]);
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-11', name: `${this.$t('Software.tscipautodistribute')}` }]);
                  $this.$refs.runEnvironmentLeft.addItem([{ id: 'list-12', name: `${this.$t('System.batchInitNECfg')}` }]);
            }
            // $this.$refs.runEnvironmentLeft.ej2Instances.refresh();

            this.$emit('getSelectItem', $this.runEnvironmentList[0].id, $this.runEnvironmentList[0].name);
            this.$refs.runEnvironmentLeft.selectItem({ id: $this.runEnvironmentList[0].id, name: $this.runEnvironmentList[0].name });
          // }
        // }
      });/*  */
    }
  },
  beforeMount() {
    //this.getInstallProductListTest();
    this.getInstallProductList();
  }
};
</script>
